import { IPasswordChangeRequest } from '@epicuro-next/data/users';
import { createAction, props } from '@ngrx/store';

export const changePassword = createAction(
  '[User] Change password',
  props<{
    passwordChangeRequest: IPasswordChangeRequest;
  }>(),
);
export const changePasswordSuccess = createAction(
  '[User] Change password success',
);

export const changePasswordFail = createAction(
  '[User] Change password fail',
  props<{ errors?: ReadonlyArray<string> }>(),
);

export const changePasswordFormOpened = createAction(
  '[User] Change password form opened',
);
